import { gql } from "@apollo/client";

export const TRANSACTION_INFO = gql`
  fragment transactionInfo on Transaction {
    id
    transactionNo
    status
    amount
    action
    createdAt
  }
`;

export const MEMBER_INFO = gql`
  fragment memberInfo on Member {
    id
    balance
    memberId
    email
    phone
    displayName
    country
    gender
    address
    city
    memberStatus
    avatar {
      id
      url
    }
    identityDoc {
      status
    }
    isVerifiedEmail
    isVerifiedIdentity
    isUpdatePersonalData
    updatedAccount
    withdrawPassword
    createdAt
    account {
      accountType
      crypto {
        address
        network
      }
      bank {
        accountNo
        accountName
        name
        lastname
      }
    }
  }
`;

export const TIMER_INFO = gql`
  fragment timerInfo on Timer {
    id
    label
    minimum
    timerRange
    expectedReturn
  }
`;

export const TRADE_INFO = gql`
  fragment tradeInfo on Trade {
    id
    symbol
    symbolLogo
    symbolName
    member {
      id
      email
    }
    assetTimer {
      id
      closeTime
      status
      timer {
        id
        timerRange
        expectedReturn
        minimum
        label
      }
    }
    investment
    positionType
    positionId
    openingTime
    closingTime
    openingPrice
    closingPrice
    closingMethod
    return {
      amount
      percent
      type
    }
    createdAt
  }
`;

export const TRADE_INFO_NO_MEMBER = gql`
  fragment tradeInfoNoMember on Trade {
    id
    symbol
    symbolLogo
    symbolName
    investment
    positionType
    positionId
    openingTime
    closingTime
    openingPrice
    closingPrice
    closingMethod
    assetTimer {
      id
      closeTime
      status
      timer {
        id
        timerRange
        expectedReturn
        minimum
        label
      }
    }
    return {
      amount
      percent
      type
    }
    createdAt
  }
`;

export const MESSAGE_INFO = gql`
  fragment messageInfo on Message {
    id
    isAdmin
    isGreet
    chatRoom {
      id
    }
    member {
      id
      memberId
    }
    text {
      message
      image {
        id
        url
      }
      isImage
    }
    createdAt
  }
`;

export const ROOM_INFO = gql`
  fragment roomInfo on Room {
    id
    name
    engName
    isRequireMinimumBalance
    minimumBalance
    minimumBalance
    minimumBuy
  }
`;
